import type { Account } from "./types";

export type AccountFlow = "income" | "expense";

export type AccountSignExpectation = {
  expected: AccountFlow;
  expectedSign: 1 | -1;
};

const inferFlowFromAccountNumber = (number: string | null | undefined): AccountFlow | null => {
  if (!number) {
    return null;
  }
  if (number.startsWith("4") || number === "9010") {
    return "income";
  }
  if (
    number.startsWith("5") ||
    number.startsWith("7") ||
    number === "8100" ||
    number === "8200" ||
    number === "8300" ||
    number === "9020"
  ) {
    return "expense";
  }
  return null;
};

export const getAccountSignExpectation = (
  account: Pick<Account, "flow" | "number"> | null,
): AccountSignExpectation | null => {
  const flow = account?.flow ?? inferFlowFromAccountNumber(account?.number) ?? null;
  if (flow !== "income" && flow !== "expense") {
    return null;
  }
  return { expected: flow, expectedSign: flow === "income" ? 1 : -1 };
};

export const isAmountSignUnexpectedForAccount = (
  account: Pick<Account, "flow" | "number"> | null,
  amount: number,
): boolean => {
  if (!Number.isFinite(amount) || amount === 0) {
    return false;
  }
  const expectation = getAccountSignExpectation(account);
  if (!expectation) {
    return false;
  }
  return Math.sign(amount) !== expectation.expectedSign;
};

